module.exports = __webpack_public_path__ + "static/media/photo_boost.fc2ff226.png";